import { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';

// project import
import { router } from './routes';
import ThemeCustomization from './themes';

import Loader from './components/Loader';
import Snackbar from './components/@extended/Snackbar';

// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

const App = () => {
  return (
    <Suspense fallback={<Loader />}>
      <ThemeCustomization>
        <RouterProvider router={router} />
        <Snackbar />
      </ThemeCustomization>
    </Suspense>
  );
};

export default App;
